import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Badge } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { OnboardingContext } from '@/utils/context/Onboarding/OnboardingContext';
import { CustomPopup } from './CustomPopup';
import { useRouter } from 'next/router';
import { useList } from '@refinedev/core';
import { CommonContentContext } from '@/utils/context/commonContent/CommonContentContext';

const OnboardingIcon = () => {
  const router = useRouter();
  const { showOnboardingProcess, setShowOnboardingProcess, finishedOnboarding, setFinishedOnboarding } =
    useContext(OnboardingContext);
  const [popUp, setPopUp] = useState(false);
  const { data: blocks } = useList({ resource: 'Blocks' });
  const { data: machines } = useList({ resource: 'Machines' });
  const { data: chemicals } = useList({ resource: 'ChemicalDetails' });
  const { data: employees } = useList({ resource: 'Employees' });

  const popupMessage =
    router.pathname === '/'
      ? 'Click here to begin the onboarding process!'
      : 'Click here to continue with the onboarding process!';
  const handleOnboardingIcon = () => {
    setPopUp(false);
    finishedOnboarding && setFinishedOnboarding(false);
    setShowOnboardingProcess(!showOnboardingProcess);
  };

  useEffect(() => {
    if (
      blocks?.data &&
      blocks?.data.length === 0 &&
      machines?.data &&
      machines?.data.length === 0 &&
      chemicals?.data &&
      chemicals?.data.length === 0 &&
      employees?.data &&
      employees?.data.length === 0
    ) {
      setPopUp(true);
    }
  }, [blocks, machines, chemicals, employees]);
  return (
    <CustomPopup isOpen={popUp} message={popupMessage}>
      <div
        className="fixed bottom-5 right-5 z-50 cursor-pointer"
        onClick={handleOnboardingIcon}
        data-cy="onboarding-icon"
      >
        <Badge>
          <Avatar size={50} className="bg-primary">
            <QuestionCircleOutlined />
          </Avatar>
        </Badge>
      </div>
    </CustomPopup>
  );
};

export default OnboardingIcon;
